import React, {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import defaultStyle from './PublicProfileItemCard.module.scss';
import desktopPreviewStyle from './PublicProfileItemCard_desktop-preview.module.scss';
import mobilePreviewStyle from './PublicProfileItemCard_mobile-preview.module.scss';
import {useTranslation} from 'react-i18next';
import {MediakitSectionItem} from './../../features/stores/mediakitUser.slice';
import {getCurrencyLabel} from '../../constants/currencies';
import {numberFollowerFormat} from '../../Helper/generalHelper';
import {iconsMap, socialMediaLinks} from '../../constants/socialMedia';
import useWindowWidth from '../../hooks/useWindowWidth';
import {previewStyles} from '../../constants/theme';
import nonHookRequest from '../../API/nonHookRequest';
import videoIcon from "./../../assets/images/icons/al_player.svg";
import playIcon from './../../assets/images/icons/Play.svg';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface IPublicProfileItemCard {
  item: MediakitSectionItem;
  sectionType: String;
  theme: any;
  selectedStyle: string;
  mediakitUserId: string;
  index: number;
  ownerUserId?: string;
  nickname?: string;
  email?: string;
  setMonitizeID: React.Dispatch<React.SetStateAction<any>>;
  setMonetizeObj?: React.Dispatch<React.SetStateAction<any>>;
}

const PublicProfileItemCard = ({
  mediakitUserId,
  sectionType,
  selectedStyle,
  item,
  index,
  theme,
  ownerUserId,
  nickname,
  email,
  setMonitizeID,
  setMonetizeObj,
}: IPublicProfileItemCard) => {
  const {t, i18n} = useTranslation();
  // const fontFamily = isArabic(i18n.language) ? theme.arabicFont!: theme.englishFont!;
  const fontFamily = theme.englishFont!;
  const width = useWindowWidth();
  let styles: any = '';
  let cardShapeRadius = '' as any;
  let iconRadius = '' as any;
  let edgeCardPadding = '0px';
  let edgeShapeHeight = '72px';
  let videoCardRadius = '0px' as any;

  const shapeData: any = {}; // getShapeData(theme.cardShape!);
  if (selectedStyle === previewStyles.DESKTOP_PREVIEW) {
    styles = desktopPreviewStyle;
    cardShapeRadius = shapeData?.border?.desktopPreviewBorderRadius;
    iconRadius = shapeData?.icon?.desktopPreviewBorderRadius;
    videoCardRadius = shapeData?.video?.desktopPreviewBorderRadius;
    edgeShapeHeight = '18px';
    edgeCardPadding = '4px';
  } else if (selectedStyle === previewStyles.MOBILE_PREVIEW) {
    videoCardRadius = shapeData?.video?.mobilePreviewBorderRadius;
    cardShapeRadius = shapeData?.border?.mobilePreviewBorderRadius;
    iconRadius = shapeData?.icon?.mobilePreviewBorderRadius;
    styles = mobilePreviewStyle;
    edgeShapeHeight='58px';
    edgeCardPadding='10px';
  } else {
    styles = defaultStyle;
    cardShapeRadius = shapeData?.border?.borderRadius;
    iconRadius = shapeData?.icon?.borderRadius;
    videoCardRadius = shapeData?.video?.borderRadius;
    edgeCardPadding = '12px';
    edgeShapeHeight = '72px';
    if (width < 768) {
      edgeCardPadding = '16px';
      edgeShapeHeight = '58px';
    }
  }

  const img = socialMediaLinks.filter((soc:any)=>soc.key === item.platform)[0].defaultIconTransparent;
  const videoTitle: any = item.description;

  const handleLinkCount = async () => {
    if (ownerUserId && item.id) {
      await nonHookRequest({method: 'POST', url: '/analytics/linkClick/count', body: {linkId: item.id, nickname: nickname}});
    }
  };

  const handleOpenLink = async () => {
    if (!!item?.isMonetize) {
      if (selectedStyle === previewStyles.DEFAULT) {
         setMonitizeID(item.id);
         setMonetizeObj ? setMonetizeObj({type: item.platform, title: item.contentType, note: item.description ?? '', attachment: '', amount: item?.price, url: item?.url || '', currency: item?.currency, maxPrice: (Number(1000)/100) || 1000, minPrice: (Number(5)/100) || 1}) : '';
         sendMonetizationLinkClickedEvent({
            link_id: item.id,
            clevertapEvent: 'monetize_link_click',
            productType: 'Media Kit',
         });
         handleLinkCount();
     } else {
        toast(<span style={{color: 'black'}}>{'Not active from this section!'}</span>, {autoClose: 3000});
      }
      return;
    }
   
    let url = item.url;
    if (!item.url.match(/^https?:\/\//i)) {
      url = 'http://' + item.url;
    }
    window.open(url, '_blank');
    handleLinkCount();
  };

  const handleShowMoreLess = (idMore: any, idLess: any, param: any) => {
    const more: any = document.getElementById(idMore);
    const less: any = document.getElementById(idLess);
    if (more && less) {
      if (param == 'more') {
      more.style.display = 'none';
      less.style.display = 'block';
     } else {
        more.style.display = 'block';
        less.style.display = 'none';
      }
    }
  };

  const contentFooter = (
    <div className={styles.stats_container}>
        <div className={styles.stats_column}>
          <div className={styles.stats_heading}></div>
          <div className={styles.stats_data}>
            {item.channelProfileIcon && <img src={item.channelProfileIcon || iconsMap[item?.platform]} className={styles.channel} />}
            {item?.platform !== 'youtube' ? <img src={iconsMap[item?.platform]} className={styles.channel} /> : null}
          </div>        
        </div>
        <div className={styles.stats_column}>
          <div className={styles.stats_heading}>{t(item?.platform == 'instagram' ? 'engagements' : 'views')}</div>
          <div className={styles.stats_data}>{numberFollowerFormat(item?.metadata?.views)}</div>
        </div>
        <div className={styles.stats_column}>
          <div className={styles.stats_heading}>{t('likes')}</div>
          <div className={styles.stats_data}>{numberFollowerFormat(item?.metadata?.likes)}</div>
        </div>
        <div className={styles.stats_column}>
          <div className={styles.stats_heading}>{t('comments')}</div>
          <div className={styles.stats_data}>{numberFollowerFormat(item?.metadata?.comments)}</div>
        </div>
      </div>
  );

  const defaultCard = (
    <div
      className={styles.container}
      style={{
        backgroundColor: theme.cardColor!,
        boxShadow: theme.boxShadow!,
        fontFamily: fontFamily,
        color: theme.cardTextColor!,
        border: '1px solid ' + theme.borderColor,
        borderRadius: cardShapeRadius,
      }}
      onClick={handleOpenLink}
    >
      <div className={styles.icon_wrapper}>
      <div
        className={styles.icon_container}
        style={{
          backgroundColor: theme.backgroundColor!,
          borderRadius: iconRadius ? iconRadius : cardShapeRadius,
        }}
      >
          <img
            className={`${styles.icon}`}
            src={img}
            style={{
              backgroundColor: 'transparent',
              borderRadius: iconRadius ? iconRadius : cardShapeRadius,
            }}
          />
      </div>
      <div className={styles.platform_name}>
          {socialMediaLinks?.filter((e: any) => e.key == item?.platform)[0]?.name}
      </div>
      </div>

      <div className={styles.main_right}>
          <div className={styles.main_right_row}>
            <div className={styles.title_main_container}>
              <div className={styles.title}>
                {item?.contentType}
              </div>
            </div>
          </div>
          <div className={styles.main_right_row}>
              <div className={styles.platform_description}>
                {item?.description?.length > 67 ? (<>
                          <div style={{width: '100%'}} id={`show-more-${item.id}`}>{item?.description.substring(0, 40)}...<span className={styles.show_less_btn} onClick={(e) => { 
                            e.stopPropagation();
                            handleShowMoreLess(`show-more-${item?.id}`, `show-less-${item.id}`, 'more');
                            }}>{t('show_more')}</span></div>
                          <div style={{display: 'none', width: '100%'}} id={`show-less-${item.id}`}>{item?.description}<span className={styles.show_less_btn} onClick={(e) => {
                            e.stopPropagation();
                            handleShowMoreLess(`show-more-${item?.id}`, `show-less-${item.id}`, 'less');
                          }}>{t('show_less')}</span></div>
                          </>
                        ) : (item?.description || '--')}
              </div>
              
          </div>
          {<div className={`${styles.main_right_row} ${styles.flex_end}`}>
              {!!item.price && <div className={`${styles.monitize}`}>
                 {getCurrencyLabel(item.currency)} {item.platform != 'tipJar' ? numberFollowerFormat(item.price/100) : ''}
                </div>}
              {!!item.price && <div className={styles.book_btn_container}>
                <div className={styles.book_btn}>{t('book')}</div>
              </div>}
          </div>}
      </div>
    </div>
  );

  const videoCard = (
    <>
    <div
      onClick={handleOpenLink}
      className={styles.video_container}
      style={{
        // backgroundColor: theme.cardColor!,
        color: theme.cardTextColor!,
        fontFamily: fontFamily,
        borderRadius: videoCardRadius,
        // border: '1px solid '+ theme.borderColor,
        boxShadow: theme.boxShadow!,
      }}
    >

      <div className={styles.iframe_wrapper}>
        <div className={styles.player_wrapper}>
          {item?.platform == 'youtube' ? <img src={videoIcon} /> : <div className={`${styles.open_icon} ${item?.platform == 'tiktok' ? styles.tiktok_div : ''}`}>{item?.platform == 'tiktok' ? <img src={playIcon} /> : <OpenInNewIcon />}</div>}
        </div>

        <div className={styles.videoDetails}
          // style={{
          //   ...(selectedStyle === previewStyles.DESKTOP_PREVIEW && theme.cardShape !== cardShape.SQUARE.name && {borderRadius: '3px'}),
          //   ...(selectedStyle !== previewStyles.DESKTOP_PREVIEW && theme.cardShape !== cardShape.SQUARE.name && {borderRadius: '11px'}),
          // }}
          >
          <div

          >
            <img src={item.videoThumbnail!} className={styles.videoThumbnail}/>
          </div>
          <span className={styles.videoDuration}>
            {item.duration}</span>
        </div>
      </div>


      <div className={styles.description_container}>
        {/* {item.channelProfileIcon && <img src={item.channelProfileIcon} className={styles.channel} />}
        {item?.platform !== 'youtube' ? <img src={iconsMap[item?.platform]} className={styles.channel} /> : null} */}
        <p className={styles.video_title} style={{fontFamily: fontFamily, color: theme.nonCardTextColor!}}>
          {videoTitle}
        </p>
      </div>

    </div>
    {item?.metadata && contentFooter}
    </>
  );

  let cardContent;

  switch (sectionType) {
    case 'music': {
      cardContent = defaultCard;
      break;
    }
    case 'podcast': {
      cardContent = defaultCard;
      break;
    }
    case 'important_links': {
      cardContent = defaultCard;
      break;
    }
    case 'rates': {
      cardContent = defaultCard;
      break;
    }
    case 'video': {
      cardContent = videoCard;
      break;
    }
  }

  return <div>
    {cardContent}
    </div>;
};


/* eslint-disable camelcase */
interface MonetizeLinkClickEventData {
  link_id?: string;
  clevertapEvent?: string;
  productType: string;
}
const sendMonetizationLinkClickedEvent = async (data:MonetizeLinkClickEventData) => {
  nonHookRequest({
    url: '/finance/api/clevertap/monetization_links',
    method: 'POST',
    body: data,
    isShortUrl: true,
  });
};

export default PublicProfileItemCard;
